import { Box, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { TravelBooking } from '../queries';
import {
  operationalServiceMapPoints,
  operationalServiceMomentViews,
} from '../serviceMoments';
import { RouteMapCard } from './RouteMapCard';

export function OperationalServiceMoments({
  booking,
  withMap = true,
}: {
  booking: TravelBooking;
  withMap?: boolean;
}) {
  const { t } = useTranslation();
  const moments = operationalServiceMomentViews(booking);
  if (!moments.length) {
    return withMap ? (
      <RouteMapCard vertical={booking.vertical} points={booking.routePoints} />
    ) : null;
  }

  return (
    <Stack spacing={1.5}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        alignItems="stretch"
      >
        {moments.map((moment) => (
          <Box
            key={moment.direction}
            border={1}
            borderColor="divider"
            borderRadius={2}
            p={1.5}
            flex={1}
          >
            <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
              <Typography variant="subtitle2">
                {t(
                  booking.vertical === 'cars'
                    ? moment.direction === 'start'
                      ? 'travelServices.cars.pickUp'
                      : 'travelServices.cars.dropOff'
                    : moment.direction === 'start'
                      ? 'travelServices.serviceMoments.start'
                      : 'travelServices.serviceMoments.end',
                )}
              </Typography>
              {moment.source === 'request' && (
                <Chip
                  size="small"
                  variant="outlined"
                  label={t('travelServices.serviceMoments.requested')}
                />
              )}
            </Stack>
            {moment.label && (
              <Typography variant="body2" fontWeight={600}>
                {moment.label}
              </Typography>
            )}
            {moment.address && (
              <Typography variant="body2" color="text.secondary">
                {moment.address}
              </Typography>
            )}
            <Typography variant="body2" mt={0.5}>
              {[moment.date, moment.time, moment.timeZone]
                .filter(Boolean)
                .join(' · ')}
            </Typography>
          </Box>
        ))}
      </Stack>
      {withMap && (
        <RouteMapCard
          vertical={booking.vertical}
          points={operationalServiceMapPoints(booking)}
        />
      )}
    </Stack>
  );
}
